var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBehanceLogoSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_434_615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2839 21.6717C14.7987 21.4481 14.1166 21.3363 13.2414 21.3262H8.85303V26.7777H13.1716C14.0594 26.7777 14.7466 26.6609 15.2432 26.4183C16.1361 25.9737 16.5858 25.124 16.5858 23.8652C16.5858 22.8021 16.1527 22.0692 15.2839 21.6717Z",
    fill: "#807B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3398 17.4359C15.8923 17.0993 16.1666 16.501 16.1666 15.6386C16.1666 14.6872 15.8034 14.056 15.0705 13.7524C14.4405 13.5428 13.6339 13.4336 12.6572 13.4336H8.85303V17.9439H13.1779C14.0658 17.9427 14.786 17.7737 15.3398 17.4359Z",
    fill: "#807B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.599 17.812C27.6146 17.812 26.8525 18.0965 26.3114 18.6516C25.7691 19.2092 25.4312 19.9637 25.2915 20.9188H31.89C31.8151 19.904 31.4759 19.1317 30.8637 18.6071C30.2578 18.0775 29.5021 17.812 28.599 17.812Z",
    fill: "#807B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.104492V40.1045H40V0.104492H0ZM24.4494 10.7307H32.6813V12.7756H24.4494V10.7307ZM19.9848 27.4181C19.5961 28.0557 19.1147 28.5917 18.5368 29.0261C17.8852 29.5266 17.1155 29.8695 16.2302 30.0524C15.3423 30.2379 14.3795 30.3293 13.3456 30.3293H4.13565V9.88475H14.0112C16.4982 9.92159 18.2637 10.643 19.3052 12.0618C19.9314 12.9319 20.2401 13.9721 20.2401 15.1813C20.2401 16.435 19.9263 17.4333 19.2938 18.1916C18.9445 18.6197 18.425 19.0058 17.7378 19.3551C18.7781 19.7387 19.5669 20.3344 20.094 21.1625C20.6249 21.9831 20.8904 22.9852 20.8904 24.155C20.8917 25.3693 20.5944 26.4578 19.9848 27.4181ZM35.8618 23.4463H25.1975C25.2572 24.9184 25.764 25.9472 26.7293 26.5379C27.3098 26.9075 28.0147 27.0866 28.8391 27.0866C29.7117 27.0866 30.4153 26.8668 30.9641 26.4172C31.2613 26.1784 31.5217 25.8393 31.749 25.4125H35.6573C35.5557 26.2826 35.0857 27.1615 34.2385 28.0595C32.9303 29.4834 31.0923 30.1985 28.7324 30.1985C26.7814 30.1985 25.0641 29.5926 23.573 28.3949C22.0869 27.1933 21.3375 25.2385 21.3375 22.5292C21.3375 19.9902 22.0081 18.0443 23.3532 16.6903C24.7034 15.3363 26.4461 14.6606 28.5927 14.6606C29.8666 14.6606 31.0123 14.8879 32.0373 15.3426C33.0573 15.8024 33.9007 16.5239 34.5624 17.5121C35.1658 18.3847 35.5493 19.3919 35.7322 20.544C35.8364 21.2083 35.8809 22.1787 35.8618 23.4463Z",
    fill: "#807B7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_434_615"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.104492,
    width: 40,
    height: 40,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehanceLogoSvgrepocom);
export default __webpack_public_path__ + "static/media/behance-logo_svgrepo.com.504a88a209722dd69689b79dd22d6d36.svg";
export { ForwardRef as ReactComponent };